<!-- ─── STICKY HEADER ─── -->
<header class="ips-header">
  <div class="ips-wrap ips-header__inner">
    <a routerLink="/" class="ips-brand">
      <img src="assets/adventum-logo.svg" alt="Adventum Calculators" class="ips-brand__logo">
    </a>
    <div class="ips-header__crumb">
      <span>{{ calculatorName }}</span>
    </div>
    <a href="https://adventumwealth.com/" target="_blank" rel="noopener" class="ips-exit-btn">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
      <span class="ips-exit-btn__text">Back to site</span>
    </a>
  </div>
</header>

<!-- ─── STICKY STEPPER ─── -->
<nav class="ips-stepper" aria-label="Progress" *ngIf="showStepper">
  <div class="ips-wrap ips-stepper__inner">
    <div
      *ngFor="let step of steps"
      class="ips-step"
      [class.is-done]="isStepDone(step.num)"
      [class.is-active]="isStepActive(step.num)">
      <div class="ips-step__num"><span>{{ step.num }}</span></div>
      <div class="ips-step__text">
        <span class="ips-step__label">{{ step.label }}</span>
        <span class="ips-step__title">{{ step.title }}</span>
      </div>
    </div>
  </div>
</nav>

<!-- ─── MAIN SHELL: form column + rail ─── -->
<div class="ips-wrap ips-shell" [class.ips-shell--form-first]="!railFirstOnMobile">
  <main class="ips-form-col">
    <ng-content select="[formCol]"></ng-content>
  </main>
  <aside class="ips-rail"
    [style.top]="showStepper ? 'calc(var(--ips-header-h) + var(--ips-stepper-h) + 24px)' : 'calc(var(--ips-header-h) + 24px)'">
    <ng-content select="[rail]"></ng-content>
  </aside>
</div>
